import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

// Breadcrumb navigation component
const Breadcrumbs = ({ items }) => {
  const location = useLocation();
  
  // If no items provided, try to auto-generate from path
  const breadcrumbItems = items || generateBreadcrumbs(location.pathname);
  
  if (!breadcrumbItems || breadcrumbItems.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link to="/" className="breadcrumb-link">
            <Home size={14} />
            <span>Home</span>
          </Link>
        </li>
        
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="breadcrumb-item">
            <ChevronRight size={14} className="breadcrumb-separator" />
            {index === breadcrumbItems.length - 1 ? (
              <span className="breadcrumb-current" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link to={item.path} className="breadcrumb-link">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

// Auto-generate breadcrumbs from pathname
const generateBreadcrumbs = (pathname) => {
  const pathMap = {
    '/learn': { label: 'Topics', path: '/learn' },
    '/education': { label: 'Education Library', path: '/education' },
    '/videos': { label: 'Videos', path: '/videos' },
    '/after-visit': { label: 'After Visit', path: '/after-visit' },
    '/anatomy': { label: 'Anatomy Guide', path: '/anatomy' },
    '/disclaimer': { label: 'Medical Disclaimer', path: '/disclaimer' },
    '/terms': { label: 'Terms of Use', path: '/terms' },
    '/privacy': { label: 'Privacy Policy', path: '/privacy' },
    '/contact': { label: 'Contact Us', path: '/contact' }
  };

  const segments = pathname.split('/').filter(Boolean);
  const breadcrumbs = [];

  let currentPath = '';
  segments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    
    if (pathMap[currentPath]) {
      breadcrumbs.push(pathMap[currentPath]);
    } else if (index === segments.length - 1) {
      // Last segment - format as title
      const label = segment
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      breadcrumbs.push({ label, path: currentPath });
    }
  });

  return breadcrumbs;
};

export default Breadcrumbs;
